<template>
  <div class="home">
    <heads :class="!getScrolltop?'navShow':'headnavS'"></heads>
    
    <div class="swiper-wrapper" v-loading="swiperLoading">
      <swiper
        v-if="bannerArray.length > 0"
        :options="swiperOptionTop"
        class="gallery-top"
        ref="swiperTop"
      >
        
        <swiper-slide
          class="slide-1"
          v-bind:style="{backgroundImage:'url(' + item.path + ')'}"
          v-for="(item,index) in bannerArray"
          :key="index"
          @click.native.stop="handleSlideClick(item.type,item.id,item.url)"
        > 
        </swiper-slide>
        <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
        <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
        <!-- <div class="swiper-pagination" slot="pagination"></div> -->
      </swiper>
      <div class="search-wrapper">
        <div class="search-input-wrapper">
          <input
            type="text"
            class="search-input"
            v-model="searchVal"
            @keyup.enter="toSearch"
            placeholder="请输入您想查找的内容"
          />
          <div class="search-btn" @click="toSearch">
            <span class="el-icon-search"></span>
            搜索
          </div>
          <div class="search-radio">
            <el-radio v-model="radio" label="1">标题</el-radio>
            <el-radio v-model="radio" label="2">目的地</el-radio>
            <el-radio v-model="radio" label="3">领队</el-radio>
          </div>
        </div>
      </div>
    </div>

    <template v-for="(item,index) in generalList">
      <weekActivity v-if="item.styleCode.indexOf('G') !== -1 && item.linePageList[0].linePage.length > 0" :message="item" :key="index"/>
      <travelLine v-else-if="item.styleCode.indexOf('F') !== -1 && item.linePageList[0].linePage.length > 0" :message="item" :key="index"/>
      <outdoorsLine v-else-if="item.styleCode.indexOf('H') !== -1 && item.linePageList[0].linePage.length > 0" :message="item" :key="index"/>
      <travelIntroduction v-else-if="item.styleCode.indexOf('E') !== -1 && item.linePageList[0].linePage.length > 0" :message="item" :key="index"/>
    </template>

    <!-- <weekActivity />
    <travelLine />
    <outdoorsLine />
    <travelIntroduction :introduction="generalList['E']"/> -->

    <!-- <homeEnterprise></homeEnterprise> -->
    <homeFoots></homeFoots>
    <!-- <leftNav :leftTab="1" :class="getScrolltop?'navShow':'navS'"></leftNav> -->
    <rightInfo :class="getScrolltop?'navShow':'navS'"></rightInfo>
    <!-- <el-dialog title="登录" :visible.sync="centerDialogVisible" width="30%">
      <span>需要注意的是内容是默认不居中的</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>-->
  </div>
  <!-- home end -->
</template>

<script>
import heads from "@/components/comment/heads.vue";
import homeFoots from "@/components/comment/homeFoots.vue";

import leftNav from "@/components/comment/leftNav.vue";
import rightInfo from "@/components/comment/rightInfo.vue";
import weekActivity from "@/components/home/weekActivity.vue";
import travelLine from "@/components/home/travelLine.vue";
import outdoorsLine from "@/components/home/outdoorsLine.vue";
import travelIntroduction from "@/components/home/travelIntroduction.vue";

import axios from "axios";
export default {
  name: "home",
  data() {
    return {
      placeholderText: "查立项",
      titleIndex: 0,
      downloadNavArray: [],
      swiperOptionTop: {
        autoplay: true,
        loop: true,
        slidesPerview: "auto",
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },

        swiperLoading:false
      },
      swiperOptionThumbs: {
        autoplay: true,
        direction: "vertical",
        spaceBetween: 5,
        slidesPerView: "auto",
        centeredSlides: true,
        touchRatio: 0.2,
        loop: true,
        slidesPerview: "auto",
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        slideToClickedSlide: true
      },
      searchVal: "",
      bannerArray: [],
      show: false,
      top: "",
      pageArray: [],
      radio: "1",
      centerDialogVisible: true,


      //模块数据
      generalList:[],
      specialList:'',
      showCard:false,
    };
  },
  components: {
    heads,
    homeFoots,
    leftNav,
    rightInfo,
    weekActivity,
    travelLine,
    outdoorsLine,
    travelIntroduction
  },
  computed: {
    getScrolltop() {
      let _this = this;
      window.addEventListener("scroll", () => {
        _this.top =
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          window.pageYOffset;
      });
      return _this.top > 300;
    }
  },
  methods: {
    getActiyityList() {
      let self = this;
      self.generalList.map(res6 => {
        let id = res6.styleId;
        let styleCode = res6.styleCode;
        axios
          .get(`/mobile/line/lineList.jhtml`, {
            params: {
              pageNumber: 1,
              pageSize: 100,
              lineStyle: id
            }
          })
          .then(res => { //这里就是每个相应id的数据

            // if (res.data.success) {
            //   if (res6.styleCode == "C") {
            //     res6.pageArray = res.data.returnValue.lineList;
            //   } else if (res6.styleCode == "A") {
            //     res6.pageArray = this.chunkArrayInGroups(
            //       res.data.returnValue.lineList,
            //       6
            //     );
            //   } else if (res6.styleCode == "D") {
            //     res6.pageArray = res.data.returnValue.lineList;
            //   }
            //   this.showCard = true;
            // } else {
            //   this.$message("系统繁忙，请稍后再试~");
            // }
          });
      });
    },
    lineStypeList() {
      axios
      .get(`/mobile/line/pcLineStypeList.jhtml`)
      .then(res => {
        if (res.data.success) {
          if (res.data.returnValue.generalList.length) {
            this.generalList = res.data.returnValue.generalList;
            // const data = res.data.returnValue.generalList;
            // for(let i = 0 ; i < data.length ; i++){ //分类信息
            //   if(this.generalList[ data[i].styleCode ] == null) {
            //     this.generalList[ data[i].styleCode ] = [];
            //   }
            //   this.generalList[ data[i].styleCode ].push(data[i]);
            // }
          }
        } else {
          this.$message("系统繁忙，请稍后再试~");
        }
      });
    },
    setSearch(item, index) {
      this.placeholderText = item;
      this.titleIndex = index;
      console.log(this.titleIndex);
    },
    enter(index) {
      this.show = true;
    },
    leave() {
      this.show = false;
    },
    toSearch() {
      if (this.radio == "1" || this.radio == "2") {
        this.$router.push({
          path: "/searchActivity",
          query: { search: this.searchVal }
        });
      } else {
        this.$router.push({
          path: "/leaderList",
          query: { search: this.searchVal }
        });
      }
    },
    //轮播
    getBanner() {
      axios
        .get(
          // `/mobile/marquee/get.jhtml?typeName=%25e9%25a6%2596%25e9%25a1%25b5&r=0.1343166060543488`
          '/mobile/marquee/get/1.jhtml'
        )
        // .get(
        //   `/mobile/marquee/get.jhtml`
        // )
        .then(res => {
          this.loading = false;
          if (res.data.success) {
            this.bannerArray = res.data.output;
          } else {
            this.$message({
              message: "系统繁忙，请稍后再试~",
              type: "error",
              duration: 1500,
              center: true
            });
          }
          this.swiperLoading = false;
        });
    },
    handleSlideClick(type,id,url){
      // console.log('!');
      if(type === "text"){ //不是外链
        this.$router.push({ path: `/adDetails`, query: { id: id } });
      }else if(type === "image"){ //是外链
        window.location.href = url;
      }else if(type === "detailImag"){ 
        
      }
    }
  },
  mounted() {
    this.getBanner();
    this.lineStypeList();
    // this.getProjectCount();
    // this.getData();
        // axios
        //   .get(`mobile/pageHits/hits.jhtml`)
        //   .then(res => { 
        //     console.log(res);
        //   });
  },
  created() {
    this.swiperLoading = true;
    // this.$store.dispatch("getNavDw");
    // this.$store.dispatch("getNavEp");
  }
};
</script>

<style scoped>
.swiper-container {
  background-color: #fff;
}
.swiper-slide {
  background-size: cover;
  background-position: center;
  width: 100% !important;
}
.headnavS {
  display: none;
}
.navS {
  opacity: 0;
}
.navShow {
  animation: rainbow 0.8s linear;
  /* Safari and Chrome: */
  -webkit-animation: rainbow 0.8s linear;
}
@-moz-keyframes rainbow {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-o-keyframes rainbow {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes rainbow {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes rainbow {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.gallery-top {
  height: 100% !important;
  width: 100%;
}
.gallery-top .slide-1{
  background-position: center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  position: relative;
}
.gallery-top .slide-1  a {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.gallery-thumbs {
  position: absolute;
  right: 50px;
  top: 150px;
  width: 100px;
  height: 190px;
  padding: 0 5px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 5px;
}
.gallery-thumbs .swiper-slide {
  width: 100%;
  height: 50px;
  opacity: 0.4;
}
.gallery-thumbs .swiper-slide img {
  width: 80px;
  height: 50px;
}
.gallery-thumbs .swiper-slide-active {
  opacity: 1;
}
</style>

<style scoped>
.swiper-wrapper {
  position: relative;
  height: 500px;
  background: #000;
}
.swiper-wrapper >>> .swiper-pagination-bullet {
  background: #e4e4e4 !important;
}
.swiper-wrapper >>> .swiper-pagination-bullet-active {
  background: #000000 !important;
}
.swiper-pagination >>> span {
  width: 12px !important;
  height: 12px !important;
}
.search-wrapper {
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  bottom: 0px;
  z-index: 9;
  box-sizing: border-box;
  color: #fff;
  font-size: 14px;
  padding: 20px 0;
  background: rgba(0, 0, 0, 0.38);
}
.search-title {
  text-align: left;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  display: flex;
}
.title-item {
}
.search-keyword {
  display: flex;
  justify-content: flex-start;
  margin: 0 auto;
  /*margin-left: 5px;*/
  font-size: 14px;
  font-weight: 500;
}
.keyword-text {
  position: relative;
  text-align: center;
  width: 70px;
  height: 35px;
  line-height: 35px;
  margin-right: 10px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 3px;
}
.keyword-text-active:after {
  content: "";
  width: 0px;
  height: 0px;
  border-top: 8px solid #e24f4f;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  position: absolute;
  top: 35px;
  left: 22px;
}
.keyword-text-active {
  background-color: #e24f4f;
}
.search-input-wrapper {
  display: flex;
  /* background: rgba(0, 0, 0, 0.38); */
  border-radius: 4px;
  padding: 5px;
  margin-top: 8px;
  position: relative;
  width: 800px;
}
.search-input {
  flex: 1;
  padding: 0 10px;
  border: 0;
  border-radius: 4px;
  line-height: 45px;
}
.search-btn {
  background: #007741;
  padding: 12px 25px;
  border-radius: 0 4px 4px 0;
  font-size: 16px;
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 5px;
}
.search-btn:hover {
  background: #05a35c;
}
.search-radio {
  position: absolute;
  right: 120px;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
}
.num-wrapper {
  display: flex;
  padding: 5px 15px;
  justify-content: space-between;
  box-sizing: border-box;
}
.num-item {
  flex: 1;
  text-align: left;
}
.num-item span {
  font-family: Comic Sans MS;
}
.right-num {
  text-align: right;
}
.business-wrapper {
  position: relative;
  display: block;
  background: #f6f6f6;
  padding-bottom: 10px;
}
.business-list {
  display: flex;
  justify-content: space-around;
  margin: 50px 0;
}
.business-item {
  flex: 1;
  text-align: center;
  margin: 10px;
}
.business-item img {
  width: 60%;
  margin: 0 auto;
}
.business-title {
  font-size: 16px;
  color: #ff5555;
  line-height: 40px;
}
.business-info {
  font-size: 14px;
  color: #666;
}
.homeBusiness-list {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 30px;
  flex-wrap: wrap;
  justify-content: space-between;
}

.homeBusiness-item {
  position: relative;
  width: 280px;
  height: 390px;
  margin-top: 20px;
  /*padding: 10px;*/
  /*border-radius: 5px;*/
  box-shadow: 0 0 10px #ccc;
  background: #fff;
  cursor: pointer;
  /*transition: 0.8s;*/
  -webkit-transition: all 0.8s ease-in-out;
  -moz-transition: all 0.8s ease-in-out;
  transition: all 0.8s ease-in-out;
  transform-style: preserve-3d;
  -moz-transform-style: preserve-3d;
}
.red {
  border: 3px solid #fff;
  color: #fff;
}
.blue {
  border: 3px solid #fff;
  color: #fff;
}
.yellow {
  border: 3px solid #ffffff;
  color: #ffffff;
}

.infoShow {
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -ms-backface-visibility: hidden;
  backface-visibility: hidden;

  overflow: hidden;
  z-index: 1;
  -webkit-transition: all 0.8s ease-in-out;
  -moz-transition: all 0.8s ease-in-out;
  transition: all 0.8s ease-in-out;
}
.info-color > img {
  /*width: 100%;*/
  width: 280px;
  height: 329px;
  /*background: ;*/
  /*padding: 20px 0;*/
  /*background: #ffbaba;*/
}
.infoShow i {
  font-size: 24px;
  margin: 0px auto;
  display: block;
  border-radius: 80px;
  width: 80px;
  height: 80px;
  line-height: 80px;
}
.info-bottom {
  display: flex;
  line-height: 60px;
  justify-content: center;
}
.titleNum {
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 40px;
  background: #ffde55;
  margin-top: 10px;
}

.info-bottom h3 {
  margin-left: 16px;
  color: #333333;
  font-size: 20px;
  font-weight: 500;
}
.info h2 {
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 40px;
  background: #ffde55;
  margin: 0 auto;
  font-weight: 500;
  position: absolute;
  bottom: 5px;
  left: 50%;
  margin-left: -20px;
}

.infoShow p {
  color: #333333;
  font-size: 14px;
}
.homeBusiness-item .info {
  position: absolute;
  border-radius: 5px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  color: #333333;
  text-align: center;
  padding: 20px 10px;
  backface-visibility: hidden;
  overflow: hidden;
  transform: rotateY(180deg);
  -webkit-transform: rotateY(180deg); /* Chrome and Safari */
  -moz-transform: rotateY(180deg); /* Firefox */
}
/*.homeBusiness-item .info {*/
/*  position: absolute;*/
/*  border-radius: 5px;*/
/*  top: 0;*/
/*  bottom: 0;*/
/*  left: 0;*/
/*  right: 0;*/
/*  color: #fff;*/
/*  text-align: center;*/
/*  -webkit-backface-visibility: hidden; !* 隐藏旋转元素的背面*!*/
/*  backface-visibility: hidden;*/
/*  background: rgba(0, 0, 0, 0.6); !*后面这个0.6是指的背景的透明度*!*/
/*  opacity: 0;*/
/*  -webkit-transition: all 0.8s ease-in-out; !*规定提示信息怎样出现ease-in-out以慢速度开始和结束*!*/
/*  -moz-transition: all 0.8s ease-in-out;*/
/*  transition: all 0.8s ease-in-out;*/
/*  padding: 20px 10px;*/
/*}*/
.info h5 {
  color: #333;
  /* border-left: 1px solid #666;
  border-right: 1px solid #666; */
  /* border-top: 1px dashed #fed911;*/
  border-bottom: 1px solid #fed911;
  line-height: 40px;
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 10px;
  position: relative;
  text-align: center;
}
/* .info h5::before {
  content: "";
  width: 1px;
  background: #999;
  height: 10px;
  position: absolute;
  left: -15px;
  top: 5px;
}
.info h5::after {
  content: "";
  width: 1px;
  background: #999;
  height: 10px;
  position: absolute;
  right: -15px;
  top: 5px;
} */
.info p {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  font-size: 18px;
  line-height: 30px;
}

/* .homeBusiness-item:hover{
  transform:rotateY(180deg);
} */

.homeBusiness-item:hover {
  transform: rotateY(180deg);
  -webkit-transform: rotateY(180deg); /* Chrome and Safari */
  -moz-transform: rotateY(180deg); /* Firefox */
}
.homeBusiness-item:hover .infoShow {
  opacity: 0;
  -webkit-transition: all 0.8s ease-in-out;
  -moz-transition: all 0.8s ease-in-out;
  transition: all 0.8s ease-in-out;
}
</style>
<style >
.search-radio .el-radio__input.is-checked .el-radio__inner {
  border-color: #007741 !important;
  background: #007741 !important;
}
.search-radio .el-radio__input.is-checked + .el-radio__label {
  color: #007741 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue